import React, {useCallback, useEffect, useState} from 'react';
import {Button, Grid, IconButton, Stack, Tooltip} from '@mui/material';
import {UseFormReturn, useWatch} from 'react-hook-form';
import {FormOperacionControlOperativoDetalle, OperacionControlOperativoDetalle} from '../types/types';
import {AsyncSelect, ControlledTextField} from "../../../../../components/forms";
import {OperacionControlOperativoDetalleFields} from "../types/fields";
import {EntityWithIdAndDescriptionFields} from "../../../../../types";
import {HttpCacheOperacion} from "../../../api/httpCacheOperacion";
import Icon from "../../../../../@core/components/icon";
import {OperacionCapitalMarketsDetalleFields} from "../../capital_markets/types/fields";

interface ControlOperativoDetalleFormProps {
  codPais: number;
  formMethods: UseFormReturn<FormOperacionControlOperativoDetalle>;
  onSubmitForm: (data: FormOperacionControlOperativoDetalle) => void;
  detalle?: OperacionControlOperativoDetalle;
}

function ControlOperativoDetalleForm({
                                       codPais,
                                       formMethods,
                                       onSubmitForm,
                                       detalle,
                                       ...props
                                     }: ControlOperativoDetalleFormProps) {
  const [freeSoloSociedad, setFreeSoloSociedad] = useState<boolean>(false);
  const [freeSoloControl, setFreeSoloControl] = useState<boolean>(false);

  const {control, handleSubmit, formState: {errors}} = formMethods;

  const watchControlTipo = useWatch({
    control: control,
    name: OperacionControlOperativoDetalleFields.Control
  })

  useEffect(() => {
    if (watchControlTipo === null) {
      setFreeSoloControl(true)
    }
  }, [watchControlTipo])

  const getOpcionesSociedad = useCallback(() => {
    return HttpCacheOperacion.getControlOperativoSociedadTipos(codPais)
  }, [codPais])

  const getOpcionesControl = useCallback(() => {
    return HttpCacheOperacion.getControlOperativoControlTipos(codPais)
  }, [codPais])

  return (
    <Grid container spacing={3} sx={{mt: 1}}>
      <Grid item xs={12}>
        {
          !freeSoloSociedad ?
            <AsyncSelect loadOptions={getOpcionesSociedad}
                         control={control}
                         name={OperacionControlOperativoDetalleFields.Sociedad}
                         label='Sociedad'
                         valueField={EntityWithIdAndDescriptionFields.Description}
                         selectNotNulleable
                         fullWidth
            /> :
            <Stack direction={'row'}>
              <ControlledTextField
                control={control}
                name={OperacionControlOperativoDetalleFields.Sociedad}
                label='Sociedad'
                fullWidth
              />
              <Tooltip title='Ver opciones'>
                <IconButton onClick={() => {
                  setFreeSoloSociedad(false)
                }}>
                  <Icon icon={'mdi:menu'}/>
                </IconButton>
              </Tooltip>
            </Stack>

        }
      </Grid>

      <Grid item xs={12}>
        {
          !freeSoloControl ?
            <AsyncSelect loadOptions={getOpcionesControl}
                         control={control}
                         name={OperacionControlOperativoDetalleFields.Control}
                         label='Control'
                         valueField={EntityWithIdAndDescriptionFields.Description}
                         nullOptionLabel={'Otros'}
                         fullWidth
            /> :
            <Stack direction={'row'}>
              <ControlledTextField
                control={control}
                name={OperacionControlOperativoDetalleFields.Control}
                label='Control'
                fullWidth
              />
              <Tooltip title='Ver opciones'>
                <IconButton onClick={() => {
                  setFreeSoloControl(false)
                }}>
                  <Icon icon={'mdi:menu'}/>
                </IconButton>
              </Tooltip>
            </Stack>

        }
      </Grid>

      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionControlOperativoDetalleFields.Descripcion}
          label='Descripción'
          fullWidth
          size='small'
        />
      </Grid>
      <Grid item xs={12}>
        <ControlledTextField
          control={control}
          name={OperacionControlOperativoDetalleFields.Conclusion}
          label='Conclusión'
          fullWidth
          size='small'
        />
      </Grid>
      {
        detalle &&
          <Grid item container xs={12} justifyContent={'flex-end'} direction={'row'} mt={3}>
              <Grid item container xs={4} justifyContent={'flex-end'}>
                  <Button variant='contained' color='primary' onClick={handleSubmit(onSubmitForm)}>
                      Confirmar
                  </Button>
              </Grid>
          </Grid>
      }
    </Grid>
  );
}

export default ControlOperativoDetalleForm;